import React, { useState, useEffect } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';

export default function BasicEditor({value, returnChange}) {
  const [content, setContent] = useState(value)

  useEffect(() => {
    returnChange(content)
  }, [content])

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false]}],
      ["bold", "italic", "link"]
    ]
  }

  return (
    <div style={{height: "fit-content"}}>
      <ReactQuill
        theme="snow"
        value={content}
        onChange={setContent}
        className="editor-state"
        modules={modules}
      />
    </div>
  )
}
